import { useEffect, useState } from 'react'
import { client } from '../lib/api'

type AffiliateData = {
  code: string
  referrals: number
  creditsEarned: number
  referrerReward: number
  refereeReward: number
  sharePath: string
  shareUrl: string
}

export function AffiliateDashboard({
  notify,
  onBack,
}: {
  notify: (msg: string) => void
  onBack: () => void
}) {
  const [data, setData] = useState<AffiliateData | null>(null)

  useEffect(() => {
    void client
      .affiliate()
      .then(setData)
      .catch((e) => notify((e as Error).message))
  }, [notify])

  const copy = async () => {
    if (!data?.shareUrl) return
    try {
      await navigator.clipboard.writeText(data.shareUrl)
      notify('Invite link copied')
    } catch {
      notify(data.shareUrl)
    }
  }

  return (
    <div className="panel-page">
      <button className="text-button back-nav" onClick={onBack} type="button">
        ← Back
      </button>
      <span className="eyebrow">Grow PairVelle</span>
      <h1>Affiliate dashboard</h1>
      <p className="page-sub">
        Bring someone interesting. You both get {data?.referrerReward ?? 50} credits after they complete verification.
      </p>

      {!data ? (
        <div className="loading-center">
          <div className="spinner" />
        </div>
      ) : (
        <>
          <div className="affiliate-stats">
            <div>
              <small>Invites</small>
              <strong>{data.referrals}</strong>
            </div>
            <div>
              <small>Credits earned</small>
              <strong>{data.creditsEarned}</strong>
            </div>
            <div>
              <small>Your reward</small>
              <strong>+{data.referrerReward}</strong>
            </div>
            <div>
              <small>Their bonus</small>
              <strong>+{data.refereeReward}</strong>
            </div>
          </div>

          <div className="settings-card" style={{ marginTop: 16 }}>
            <div style={{ padding: '16px 18px' }}>
              <small>Your invite code</small>
              <strong style={{ display: 'block', marginTop: 4, fontSize: 22 }}>{data.code}</strong>
              <div className="affiliate-share">
                <code>{data.shareUrl}</code>
                <button type="button" className="button primary" onClick={() => void copy()}>
                  Copy invite link
                </button>
              </div>
              <p className="field-hint" style={{ marginTop: 12 }}>
                You earn {data.referrerReward} credits per signup. New members get {data.refereeReward} bonus credits.
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
